<template>
  <div>
    <a class="mb-2 btn-transition btn btn-outline-success" href="#" @click.prevent="handleAddItem">Add new</a>
    <div class="grid-stack-container"><div class="grid-stack" ref="gridStackContainer"></div></div>
  </div>
</template>

<script>
import { GridStack } from 'gridstack'
import { createVNode, render } from 'vue'
import Item from './LayoutConfig/Item.vue'
export default {
  data() {
    return {
      instance: null,
      debounce: {
        update: _.debounce(this.update, 100),
        change: _.debounce(this.change, 100)
      }
    }
  },
  mounted() {
    this.instance = GridStack.init(
      {
        float: false,
        cellHeight: '60px',
        minRow: 1
      },
      this.$refs.gridStackContainer
    )
    this.instance.on('added removed change', this.debounce.change)
    if (_.isArray(this.data)) this.debounce.update()
  },
  unmounted() {
    try {
      this.instance?.off('added removed change', this.debounce.change)
      this.instance?.destroy()
    } catch {
      //
    }
    this.instance = null
  },
  computed: {
    data() {
      return _.isArray(this.config?.data) ? this.config?.data : []
    },
    components() {
      return this.config?.components
    }
  },
  methods: {
    renderItem(data) {
      const el = document.createElement('div')
      render(
        createVNode(Item, {
          ...data,
          onEdit: this.handleEditItem,
          onRemove: this.handleRemoveItem
        }),
        el
      )
      return el
    },
    getItemData(data) {
      return this.$util.only(['index', 'x', 'y', 'w', 'h', 'minW', 'maxW', 'maxH', 'minH', 'widget'], data)
    },
    update() {
      this.data.forEach((widgetData, index) => {
        let el = this.$refs.gridStackContainer.querySelector(`.grid-stack-item-content[x="${widgetData.x}"][y="${widgetData.y}"]`)?.closest('.grid-stack-item')
        widgetData = Object.assign({}, widgetData, this.components?.[widgetData?.widget?.component]?.grid || {})
        if (!widgetData?.index) widgetData.index = index
        if (!widgetData?.widget?.label) widgetData.widget.label = this.components?.[widgetData?.widget?.component]?.label || ''
        if (!widgetData?.widget?.description) widgetData.widget.description = this.components?.[widgetData?.widget?.component]?.description || ''
        if (el instanceof Element) {
          this.instance.update(el, widgetData)
        } else {
          this.instance.makeWidget(this.renderItem(widgetData), widgetData)
        }
      })
    },
    handleAddItem() {
      this.$emitter.emit('Modal', {
        name: `LayoutConfig.Create`,
        data: this.components,
        $el: this.$refs.gridStackContainer,
        callback: this.handleAddedItem
      })
    },
    handleAddedItem({ component, components }) {
      let grid = components?.[component]?.grid || {}
      let widgetData = {
        x: 0,
        y: 0,
        w: 1,
        h: 1,
        ...grid,
        index: this.data.length,
        widget: {
          label: components?.[component]?.label || '',
          description: components?.[component]?.description || '',
          component: component,
          data: {}
        }
      }
      this.instance.makeWidget(this.renderItem(widgetData), widgetData)
    },
    handleEditItem({ widget, index }) {
      this.$emitter.emit('Modal', {
        name: this.components?.[widget.component]?.component || null,
        $el: this.$refs.gridStackContainer,
        data: widget.data || {},
        index,
        callback: this.handleEditedItem
      })
    },
    handleEditedItem({ data, index }) {
      let gridData = this.data || null
      let widgetData = gridData?.[index] || null
      if (!widgetData) console.error(index, this.data)
      widgetData.widget.data = data
      let el = this.$refs.gridStackContainer.querySelector(`.grid-stack-item-content[x="${widgetData.x}"][y="${widgetData.y}"]`).closest('.grid-stack-item')
      if (el instanceof Element) {
        this.instance.removeWidget(el)
      }
      widgetData = this.getItemData(widgetData)
      this.instance.makeWidget(this.renderItem(widgetData), widgetData)
    },
    handleRemoveItem({ ref }) {
      this.instance.removeWidget(ref.$el.parentNode)
    },
    change() {
      let data = this.instance.save()
      data.forEach((value, index) => {
        value.index = index
        if (value.maxW) value.w = Math.min(12, value.w, value.maxW) || value.maxW
        if (value.minW) value.w = Math.max(1, value.w, value.minW) || value.minW
        if (value.maxH) value.h = Math.min(12, value.h, value.maxH) || value.maxH
        if (value.minH) value.h = Math.max(value.h, value.minH) || value.minH
        data[index] = this.getItemData(value)
      })
      this.$emit('changeValue', data)
    }
  },
  watch: {
    data(value) {
      if (_.isArray(value)) this.debounce.update()
    }
  },
  props: {
    config: Object
  }
}
</script>
<style src="gridstack/dist/gridstack.min.css"></style>
<style lang="scss">
.grid-stack-container {
  background: #efefef;
  border-radius: var(--border-radius, 0.25rem);
  padding: 5px;
  .grid-stack-item-content {
    background-color: #fff;
    border-radius: var(--border-radius, 0.25rem);
    overflow: hidden !important;
    label {
      font-size: 90%;
      font-weight: 500;
      display: -webkit-box !important;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0;
      font-size: 90%;
      font-weight: 500;
      line-height: 1;
    }
  }
}
</style>
